module.exports = {"id":"239818","name":"Rúben Dias","rating":"75","photo":"./data/images/photos/4/239818.png","club":{"name":"SL Benfica","logo":"./data/images/clubs/SLBenfica.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenDias0.json
// module id = 3730
// module chunks = 0